import { Component, input } from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import { MceEditorComponent } from '../../../shared/components/mce-editor/mce-editor.component';
import { CableComments } from './cable-comments.model';

@Component({
  selector: 'cable-edit-comments',
  imports: [MceEditorComponent],
  templateUrl: './cable-comments.component.html'
})
export class CableCommentsComponent {

  readonly form = input.required<FieldTree<CableComments>>();

}
